import { render, staticRenderFns } from "./BasCurrencyList.vue?vue&type=template&id=580f522e&scoped=true&"
import script from "./BasCurrencyList.vue?vue&type=script&lang=js&"
export * from "./BasCurrencyList.vue?vue&type=script&lang=js&"
import style0 from "./BasCurrencyList.vue?vue&type=style&index=0&id=580f522e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "580f522e",
  null
  
)

export default component.exports